'use client';

import { useMemo } from 'react';
import FrequentlyAskedQuestions from '~/components/vm/FaqSection/FrequentlyAskedQuestions';
import { haversineDistance } from '~/components/vm/MapSection/utils';
import { useGlobalContext } from '~/context/vm/GlobalContext';
import type { VendingMachineLocation } from '~/contracts/vm';

type Props = {
  vendingMachineLocations: VendingMachineLocation[];
};

export default function FaqSection({ vendingMachineLocations }: Props) {
  const { geoCoords } = useGlobalContext();

  const sortedVendingMachines = useMemo(
    () =>
      geoCoords
        ? vendingMachineLocations
            .map(x => ({ ...x, distance: haversineDistance(x, geoCoords) }))
            .sort((a, b) => a.distance.mi - b.distance.mi)
        : vendingMachineLocations,
    [geoCoords, vendingMachineLocations]
  );

  return (
    <FrequentlyAskedQuestions vendingMachineLocations={sortedVendingMachines} />
  );
}
